import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_AGGREGATED_CALENDAR_EXPENSES_BY_DAY';

export async function getAggregatedCalendarExpensesByDay(
    userData: Record<string, string>,
    before: string,
    after: string,
    query?: string
) {

    try {
        const response = await axios.get(
            `${URL}/expenses/calendar/day/?before=${before}&after=${after}&${query}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userData.userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        console.log(error);
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des frais',
            error: error
        });
    }
}
